// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content_loading__p1jfl {\n  margin-left: var(--layout-01);\n  width: 128px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/molecules/tasks/followers/content/content.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;AACd","sourcesContent":[".loading {\n  margin-left: var(--layout-01);\n  width: 128px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": "content_loading__p1jfl"
};
export default ___CSS_LOADER_EXPORT___;
